import { useMemo } from "react";
import { useDebounce } from "@/hooks/use-debounce";
import { useGetPharmacyByType } from "@/queries/patient-chart/order/use-get-pharmacy-by-type";
import { GetAllPharmacyLabRadiologyTypeEnum } from "@/services";
import { getXtenantId } from "@/utils/utils";
import { PHARMACY_LIST_PAGE_SIZE } from "../readmission-f2f-constant";
import { PharmacyEntry } from "../readmission-f2f-types";
import { toPharmacyEntries } from "../readmission-f2f-pharmacy-utils";

export interface UsePharmacyDirectory {
  pharmacies: PharmacyEntry[];
  isLoading: boolean;
  setSearch: (value: string) => void;
}

/** The system's pharmacy preferences, the same list the patient's Add New Preferences form writes to. */
export const usePharmacyDirectory = (
  isEnabled: boolean
): UsePharmacyDirectory => {
  const [searchString, setSearch] = useDebounce<string>("");
  const { data, isFetching } = useGetPharmacyByType({
    pagination: { page: 0, pageSize: PHARMACY_LIST_PAGE_SIZE },
    gridSorting: [],
    type: GetAllPharmacyLabRadiologyTypeEnum.Pharmacy,
    searchString,
    xTENANTID: getXtenantId(),
    enabled: isEnabled,
  });

  const pharmacies = useMemo(
    () => toPharmacyEntries(data?.data?.content),
    [data?.data?.content]
  );

  return useMemo(
    () => ({ pharmacies, isLoading: isFetching, setSearch }),
    [pharmacies, isFetching, setSearch]
  );
};
